import { Box } from '@chakra-ui/react';

import { dateUtils } from 'shared_DEPRECATED/utils';

import { ScheduledMessageEmptyState } from 'features/chat/components/ChatMessagesScheduling/EmptyStateContainer';
import { ScheduleListHeader } from 'features/chat/components/ChatMessagesScheduling/ScheduleListHeader';
import { ScheduledChatMessage } from 'features/chat/components/ChatMessagesScheduling/ScheduledMessage';
import { PlainMessageContent } from 'features/chat/config/types/Message';
import { ScheduledMessage } from 'features/chat/config/types/ScheduledMessage';
import { ChatMessageProvider } from 'features/chat/context/chatMessage';

type ChatMessageScheduleListProps = {
  onClose: () => void;
  messages: ScheduledMessage[];
};

export const ScheduledChatMessages = ({
  onClose,
  messages,
}: ChatMessageScheduleListProps) => {
  let messageDate = '';

  const hasMessages = messages.length > 0;

  return (
    <ChatMessageProvider isIncoming={false}>
      <Box p="0 1rem 1rem">
        <ScheduleListHeader onClose={onClose} />

        <Box data-testid="scroll-container">
          <ScheduledMessageEmptyState hasItems={hasMessages}>
            {messages.map((message) => {
              const formattedDate = dateUtils.relativeDateFormat(
                message.scheduledFor
              );
              const isSameDate = messageDate === formattedDate;
              if (!isSameDate) {
                messageDate = formattedDate;
              }
              return (
                <ScheduledChatMessage
                  key={message.messageId}
                  messageId={message.messageId}
                  isTemporary={!!message?.temporaryMessageId}
                  text={message.text}
                  divider={!isSameDate ? formattedDate : ''}
                  scheduledFor={message.scheduledFor}
                  attachments={message.attachments || []}
                  linkPreview={
                    (message.content as PlainMessageContent)?.linkPreview
                  }
                />
              );
            })}
          </ScheduledMessageEmptyState>
        </Box>
      </Box>
    </ChatMessageProvider>
  );
};
